var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.41104 6.99555L7.70655 12.2949C7.79956 12.3876 7.87336 12.4978 7.92372 12.6191C7.97408 12.7405 8 12.8706 8 13.002C8 13.1334 7.97408 13.2635 7.92372 13.3849C7.87336 13.5062 7.79956 13.6164 7.70655 13.7091C7.51784 13.8955 7.26346 14 6.99843 14C6.7334 14 6.47901 13.8955 6.29031 13.7091L0.291468 7.70542C0.109904 7.52322 0.00556866 7.27787 0.000215224 7.02052C-0.00513869 6.76316 0.0889027 6.51367 0.262732 6.32406L6.2862 0.277862C6.47495 0.097047 6.72682 -0.00265922 6.988 5.39087e-05C7.24918 0.00276704 7.49893 0.107684 7.68389 0.292382C7.86885 0.477079 7.97433 0.726905 7.9778 0.988463C7.98127 1.25002 7.88244 1.50256 7.70245 1.69211L2.41104 6.99555Z",
    fill: "#242529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderArrowLeft);
export default __webpack_public_path__ + "static/media/calender-arrow-left.7b9cc8992b4209f3a9c4cf5c354404ba.svg";
export { ForwardRef as ReactComponent };